import React, { useContext } from "react";
import PropTypes from "prop-types";
import HDFComponent from "./HDFComponent";
import { HdfDataContext } from "../index";
import humps from "humps";

const Question = ({ members, label, components }) => {
  const allMembers = useContext(HdfDataContext).eligibleMembers || [];
  const eligibleMembers = members || allMembers || [];
  return (
    <div className="hdf-question">
      <div>{label}</div>
      {eligibleMembers.map(member => {
        return (
          components &&
          components.map(comp => {
            return (
              <HDFComponent
                key={comp.id}
                style={{ width: "100%", padding: "0.5rem", fontSize: "1rem" }}
                comp={comp}
                label={
                  comp.type === "radio"
                    ? `${member.relationship || member.type}-${member.name}`
                    : ""
                }
                prefix={`${humps.camelize(member.relationshipDetail)}`}
              />
            );
          })
        );
      })}
    </div>
  );
};

Question.propTypes = {
  label: PropTypes.string,
  components: PropTypes.array,
  members: PropTypes.array,
};

export default Question;



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/components/Question.js